import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from './productSlice';
import ProductCard from '../../components/ProductCard';
import MarketplaceNavbar from '../../components/MarketplaceNavbar'
import "./myorders.css"
import { makeAuthenticatedGETRequest } from '../services/serverHelper';
import { orderPoints, productPoints } from '../services/apis';
import { toast, ToastContainer } from "react-toastify";

const MyProducts = () => {
    const dispatch = useDispatch();
    const {accessToken} = useSelector(state => state.auth);
    const [data, setData] = useState([])
    const id = localStorage.getItem('artId');

    useEffect(() => {
        fetchProducts()
      }, []);
    
    const fetchProducts = async() => {

        try {
            const response = await makeAuthenticatedGETRequest(
                `${orderPoints.FETCH_USER_ORDERS_API}/${id}`,
                accessToken
            );
            setData(response.data.orders); 
            console.log(response.data.orders);
        } catch (error) {
           toast.error('Unable to Fetch Orders.') 
        }

    }
  return (
    <div>
      <MarketplaceNavbar />
      {/* <div className="marketplace-home">
        <h1 className="marketplace-title">Products</h1> */}


        <div className='products-main'>
      {data && data.length === 0 ? (
          <div className="text-center">
            <p>No Orders made.</p>
          </div>
        ) : (


          <div className="my-orders-container">
            <h2>My Orders</h2>

            <div className="orders-table">
              <div className="table-header">
                <div>Order ID</div>
                <div>Product Name(s)</div>
                <div>Transaction ID</div>
                <div>Email ID</div>
                <div>Status</div>
              </div>

              {data?.map((order) => (
                <div className="table-row" key={order._id}>
                  <div>{order._id}</div>

                  <div>
                    {order.productId?.map((product, index) => (
                      <span key={index}>
                        {product.title}
                        {index !== order.productId.length - 1 ? ", " : ""}
                      </span>
                    ))}
                  </div>

                  <div>{order.payment.transactionId}</div>

                  <div>{order.emailId}</div>

                  <div>
                    <span
                      className={`orders-status-badge ${
                        order.payment?.paymentStatus?.toLowerCase() || ""
                      }`}
                    >
                      {order.payment.paymentStatus}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
        )} 
      {/* </div> */}
      </div>
    </div>
  )
}

export default MyProducts